/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:33:22
 */
import * as types from './mutation-types';
import permissionMutation from './modules/permission/mutation';
import userMutation from './modules/user/mutation';
import systemMutation from './modules/system/mutation';
import teamMutation from './modules/team/mutation';

const mutations = {
	...permissionMutation,
	...userMutation,
	...systemMutation,
	...teamMutation,
	[types.HOST_APP_KEY](state, val) {
		state.vuex_hostAppKey = val;
		localStorage.setItem('vuex_hostAppKey', val);
	},
	[types.SHARE_ID](state, val) {
		state.vuex_shareId = val;
		sessionStorage.setItem('vuex_shareId', val);
	},
	[types.SHOP_ID](state, val) {
		state.vuex_shopId = val;
		sessionStorage.setItem('vuex_shopId', val);
	},
	[types.BASE_INFO](state, obj) {
		state.vuex_baseInfo = obj;
	},
	[types.DY_CATEGORY](state, obj) {
		state.vuex_dy_category = obj;
		localStorage.setItem('vuex_dy_category', JSON.stringify(obj));
	},
	[types.KS_CATEGORY](state, obj) {
		state.vuex_ks_category = obj;
		localStorage.setItem('vuex_ks_category', JSON.stringify(obj));
	},
	[types.SP_CATEGORY](state, obj) {
		state.vuex_sp_category = obj;
		localStorage.setItem('vuex_sp_category', JSON.stringify(obj));
	},
	[types.ALERT_MSG](state, val) {
		state.vuex_alert_msg = val;
	},
	[types.UPDATE_INFO](state, val) {
		state.update = val;
	},
};

export default mutations;
